<template>
  <!-- 横屏 -->
  <horizontalScreen class="v-game-course"> 
    <!-- <scaleWrap> -->
      <div class="home">
          <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)" :id="`word${index}`" class="word" v-for="(word, index) in showWordList.slice(0, 3)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
          <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)" :id="`word${index+3}`" class="word" v-for="(word, index) in showWordList.slice(3, 6)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
        
        <!-- <div class="word-container">
          <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :id="`word${index+6}`" class="word" v-for="(word, index) in showWordList.slice(6, 9)" :key="word.name">
            <img src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/anime/type0/0.png"/>
            <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :style="{backgroundImage: 'url(' + word.icon + ')'}"></div>
          </div>
        </div> -->
        <!-- <img id="person" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/walk/0.png"> -->
        <!-- <img id="partner" src="@/assets/game4-11/clap/0.png"> -->
        <img class="logo" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/logo.png"/>
        <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
           <img @click="backHandler" class="back" src="@/assets/back.png"/>
           <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
           <img @click="startHandler" class="voice" src="@/assets/voice.png"/>
        </div>
        <!-- <div class="sound-box-bottom"> -->
           <!-- <img @click="backHandler" class="back" src="@/assets/back.png"/> -->
           <!-- <img @click="reverseHandler" class="reverse" src="@/assets/reverse.png"/> -->
           <!-- <img @click.stop.prevent="startHandler" class="voice" src="@/assets/voice.png"/> -->
        <!-- </div> -->
        <audio id="myAudio" preload="auto"></audio>
        <audio id="failAudio" preload="auto">
          <source :src="this.failAudio">
        </audio>
        <audio id="walkAudio" preload="auto">
          <source :src="this.walkAudio">
        </audio>
        <audio id="luoshuiAudio" preload="auto">
          <source :src="this.luoshuiAudio">
        </audio>
        <Overlay class="mask-dialog" :show="showStartGameIcon">
          <img class="overlay-bg" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/bg.png"/>
          <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
            <img @click="backHandler" class="back" src="@/assets/back.png"/>
            <!-- <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
            <img @click="startHandler" class="voice" src="@/assets/voice.png"/> -->
          </div>
          <div class="mask-title">{{index}} {{gameName}}</div>
          <img @click="startGameHandler(true)" class="start" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/btn-start.png"/>
        </Overlay>
      </div>
    <!-- </scaleWrap> -->
  </horizontalScreen>
</template>
<script>
import anime from 'animejs/lib/anime.es.js'
import horizontalScreen from '@/components/horizontal-screen'
// import scaleWrap from '@/components/scale-wrap'
import {shuffle, isEmpty, cloneDeep} from 'lodash'
import { Overlay } from 'vant'
import mixin from '../mixin'
import {Howl} from 'howler'
import {isIOS} from '@/utils/env'

export default {
  name: 'GameCourse',
  mixins: [mixin],
  components: {
    // , scaleWrap
    horizontalScreen, Overlay
  },
  created () {
    this.walkAudioVoice = new Howl({
      src: [this.walkAudio],
      html5: isIOS
    });
    this.luoshuiAudioVoice = new Howl({
      src: [this.luoshuiAudio],
      html5: isIOS
    });
  },
  beforeDestroy () {
    this.walkAudioVoice.pause()
    this.luoshuiAudioVoice.pause()
  },
  data() {
    return {
      walkAudioVoice: null,
      luoshuiAudioVoice: null,
      index: this.$route.query.index,
      id: this.$route.query.id,
      gameName: null,
      walkAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/sounds/walk.mp3`,
      luoshuiAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/sounds/luoshui.mp3`,
      clickAudio: require(`@/assets/sounds/click.mp3`),
      failAudio: require(`@/assets/sounds/fail.mp3`),
      boardImgLength: 80
    }
  },
  methods: {
    isEmpty,
    // 走路动画
    // personWalkGifHandler () {
    //   clearInterval(this.timerWalk)
    //   this.timerWalk = null
    //   let i = 0
    //   const person = document.getElementById('person')
    //   this.timerWalk = setInterval(() => {
    //     this.isWalk = true
    //     // 前面17张走路
    //     if (i>=this.workImgLength) {
    //       clearInterval(this.timerWalk)
    //       this.timerWalk = null
    //       // this.isWalk = false
    //     } else {
    //       i=i+1
    //       person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/walk/${i}.png`
    //     }
    //   }, 70)
    // },
    // 挖宝动画
    // personDigGifHandler () {
    //   clearInterval(this.timerDig)
    //   this.timerDig = null
    //   let i = this.workImgLength
    //   const person = document.getElementById('person')
    //   this.timerDig = setInterval(() => {
    //     this.isWalk = true
    //     if (i >= this.digImgLength -1) {
    //       clearInterval(this.timerDig)
    //       this.timerDig = null
    //       // this.isWalk = false
    //       person.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/walk/${0}.png`
    //     } else {
    //       i=i+1
    //       person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/walk/${i}.png`
    //     }
    //   }, 70)
    // },
    // 面板动画
    boardGifHandler (id, index) {
      clearInterval(this.timerBoard)
      this.timerBoard = null
     
      const animeType = this.animeTypes
      let i = 0
      const wordTarget = document.querySelector(`#${id} div`)
      wordTarget.style.display = 'none'
      

      const target = document.querySelector(`#${id} .flower`)
      this.timerBoard = setInterval(() => {
        this.isWalk = true
        if (i == 9) {
          // document.getElementById(`walkAudio`).play()
          this.walkAudioVoice.play()
        }
        if (i == 60) {
          // document.getElementById(`luoshuiAudio`).play()
          this.luoshuiAudioVoice.play()
        }
        if (i>=this.boardImgLength-1) {
          clearInterval(this.timerBoard)
          this.timerBoard = null
          // 隐藏星星
          // target.style.display = 'none'
          // word.style.visibility = 'hidden'

          // this.isWalk = false
          this.showWordList[index].clicked = false
          target.style.display = 'none'
          target.style.zIndex = 40
          // 下一个字包括音效 
          this.getData(true)
        } else {
          i=i+1
          target.style.zIndex = 99
          target.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/anime/type${animeType}/${i}.png`
          // target.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/anime/type${animeType}/${i}.png`
        }
      }, 50)
    },
    // 打乱文字排序
    async reverseHandler() {
      if (!this.isWalk){
        clearInterval(this.timerWalk)
        this.timerWalk = null
        clearInterval(this.timerSigh)
        this.timerSigh = null
        clearInterval(this.timerClap)
        this.timerClap = null
        clearInterval(this.timerDig)
        this.timerDig = null
        clearInterval(this.timerBoard)
        this.timerBoard = null

        this.audioList = []
        await this.initData()
        
        this.showWordList = shuffle(this.InitWordList)
        this.wordList = cloneDeep(this.showWordList)
        this.$set(this, 'showWordList', shuffle(this.InitWordList)) 
        this.$set(this, 'wordList', cloneDeep(this.showWordList)) 
        for(let i =0;i<this.InitWordList.length;i++) {
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/anime/type0/${0}.png`
        }
         for(let i =0;i<this.showWordList.length;i++) {
          this.showWordList[i].clicked = false
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/anime/type0/${0}.png`
        }
        // 一切重新开始
        this.getData()
        this.startGameHandler()
      }
    },
    // 字点击
    wordClickHandler(event, word, index) {
      console.log('word', word, event.target.className)
      console.log('isWalk', this.isWalk)

      if (this.isWalk) return

      let parentNode = event.target.parentElement
      if (event.target.className == 'icon-img') {
        parentNode = event.target.parentElement.parentElement
      } else {
        parentNode = event.target.parentElement
      }
      anime({
        targets: parentNode,
        scale: [
          { value: 1, duration: 100 },
          { value: 1.1, duration: 100 },
          { value: 1, duration: 100 }
        ],
        complete: () => {
          parentNode.style.transform = 'none'
        }
      });
      
      if (this.currentWord.name !== word.name) {
        this.playClickAudio()
        this.playFailAudio()
        
        return false
      }

      this.showWordList[index].clicked = true

      this.playClickAudio()

      // const target = document.getElementById(`word${index}`)
      // const person = document.getElementById('person')
      
      // 文字消失
      const wordTarget = document.querySelector(`#word${index} div`)
      wordTarget.style.display = 'none'
      // 变换成第一个花苞
      const flowerTarget = document.querySelector(`#word${index} .flower`)
      flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/anime/type0/${0}.png`
      this.boardGifHandler(`word${index}`, index)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-game-course{
  // font-family: 'Alibaba-PuHuiTi-Bold';
  // font-family: 'FZHuPo-M04S';
audio {
  position: absolute;
  top: -1000px;
  left: -1000px;
  z-index: -1;
}
.mask-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  // background: url(~https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  .overlay-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: -1;
  }
   .mask-title {
    border: solid 3px #5f0001;
    color: #5f0001;
    font-size: 50px;
    padding: 20px 0;
    text-align: center;
    background: #fff;
    border-radius: 60px;
    width: 76%;
    margin: 5% auto;
  }
  .start {
    display: block;
    width: 124px;
  }
  .btn-restart {
    width: 223.33px;
  }
}

.home {
  height: 100%;
  width: 100%;
  background: url(https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game4-11/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
}
// .logo {
//   width: 12px;
//   left: 5px;
//   top: 10PX;
//   position: fixed;
// }
.sound-box-top {
  width: 46px;
  right: 20px;
  top: 10PX;
  z-index: 990;
  position: fixed;
  > img {
    z-index: 990;
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.sound-box-bottom {
  z-index: 990;
  width: 46px;
  right: 5px;
  bottom: 5px;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.word-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  height: 50%;
  align-items: center;
  &:nth-of-type(1) {
    // margin-left: 120px;
    margin-left: 6%;
    margin-top: 10%;
  }
  &:nth-of-type(2) {
    margin-top: -20px;
    margin-left: 6%;
  }
  .word {
    transform-origin: center;
    width:166.66px;
    height: 240.66px;
    font-size: 30px;
    margin-top: -15%;
    // font-weight: bolder;
    position: relative;
    .flower {
      position: absolute; 
      width: 100%;
      // width: 319.5px;
      // height: 416.5px;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
    & + .word {
      margin-left: 30px;
    }
    .icon {
      z-index: 60;
      display: block;
      width: 80%;
      height: 56%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 20%;
    }
    .icon-img {
      z-index: 60;
      display: block;
      width: 74px;
      height: 74px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 53%;
      transform: translateX(-50%);
      bottom: 10%;
    }
  }
}
#person {
  width: 213px;
  height: 250px;
  position: fixed;
  right: 0px;
  bottom: 0px;
  z-index: 40;
}
#partner {
  width: 203.66px;
  height: 281.5px;
  position: fixed;
  right: 10px;
  bottom: 0px;
}
}
</style>